import { assign, noop } from 'lodash';

// local dependencies
import { messageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';
import { STATUS_BAR_THEME } from 'constants/common';

// default overlay payload
const defaultOverlaySettings = {
    modalType: undefined, // type of the modal view to render (using `overlayViewResolver` service)
    showCloseButton: true, // show close button to close the overlay
    statusBarTheme: STATUS_BAR_THEME.DARK, // statusbar theme to use in mobile app platform
    enablePadding: false, // to add default padding provided by the overlay
    stack: true, // render overlay with on top of another opened overlay (stack format)
    hideOverlay: false, // hide overlay background
    transparentOverlay: false, //render `overlay` with transparent background
    transparentBackground: false, //render `view` with transparent background
    onClose: noop, // close popover window callback
    fixedToCenter: false, // place inner content to center
    fixedToBottom: false, // place inner content to bottom
    renderInfoIcon: false, // hide info icon
    ignoreOverflow: false, // do not use overflow
    ignoreOutsideClick: false, // show close button to close the overlay
};

/**
 * @desc Open an overlay window.
 * @param {*} payload - Payload contains `data` and `settings` of the overlay
 * @example
 * import { overlay } from 'modules/overlay';
 * overlay.open( payload );
 */
export const open = ( payload = {} ) => {
    messageBus.trigger( MESSAGE_BUS_EVENTS.OPEN_OVERLAY, {
        settings: assign( {}, defaultOverlaySettings, payload.settings ), // provide default options
		data: payload.data, // data used by the overlay modal view as props
		config: assign( {}, payload.config ), // config used for overlay modal view configuration.
    } );
};

/**
 * @desc Update an overlay window with new data.
 * @param {*} payload - Payload contains `id` and `data` of the overlay
 * @example
 * import { overlay } from 'modules/overlay';
 * update.update( payload );
 */
export const update = ( payload = {} ) => {
    messageBus.trigger( MESSAGE_BUS_EVENTS.UPDATE_OVERLAY, {
        id: payload.id, // provide overlay id
        data: payload.data, // data used by the overlay modal view as props
    } );
};

/**
 * @desc Close overlay window(s)
 * @param { boolean } closeAll - close all opened overlay windows or the current (last opened) overlay
 *  * @example
 * import { overlay } from 'modules/close';
 * overlay.close( { closeAll: true } );
 */
export const close = ( { closeAll = false } = {} ) => {
    messageBus.trigger( MESSAGE_BUS_EVENTS.CLOSE_OVERLAY, {
        closeAll
    } );
};
